import { Box, Text, Tooltip } from '@usealloy/component-library';
import { StyledColoredDot } from '../entities/evaluations/RiskRatingCard/styles';

type Props = {
  color?: string;
  riskOutput: number | string;
  riskLevel?: string;
};

export const RiskRatingDisplay = ({ color, riskOutput, riskLevel }: Props) => (
  <Tooltip content={riskLevel} disabled={!riskLevel} side="top" align="start">
    <Box justifyContent="flex-start" gap={1} alignItems="center" width="auto">
      <StyledColoredDot isVisible={!!color} color={color} />
      <Text>{riskOutput}</Text>
    </Box>
  </Tooltip>
);
